import React from 'react';
import { cn } from '@/lib/utils';

interface HeadingProps {
  children: React.ReactNode;
  className?: string;
  center?: boolean;
}

export function PageTitle({ children, className, center = false }: HeadingProps) {
  return (
    <h1 
      className={cn(
        "font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter mb-6",
        center && "text-center",
        "text-white",
        className
      )}
    >
      {children}
    </h1>
  );
}

export function SectionTitle({ children, className, center = false }: HeadingProps) {
  return (
    <h2 
      className={cn(
        "font-heading text-3xl md:text-4xl font-bold mb-4",
        center && "text-center",
        "text-white",
        className
      )}
    >
      {children}
    </h2>
  );
}

export function SubSectionTitle({ children, className, center = false }: HeadingProps) {
  return (
    <h3 
      className={cn(
        "font-heading text-2xl md:text-3xl font-semibold mb-3",
        center && "text-center",
        "text-white",
        className
      )}
    >
      {children}
    </h3>
  );
}

export function CardTitle({ children, className, center = false }: HeadingProps) {
  return (
    <h4 
      className={cn(
        "font-heading text-xl font-semibold mb-2",
        center && "text-center",
        "text-white",
        className
      )}
    >
      {children}
    </h4>
  );
}

interface TextProps {
  children: React.ReactNode;
  className?: string;
  center?: boolean;
  muted?: boolean;
}

export function Lead({ children, className, center = false, muted = false }: TextProps) {
  return (
    <p 
      className={cn(
        "text-lg sm:text-xl leading-relaxed",
        center && "text-center",
        muted ? "text-white/60" : "text-white/75",
        className
      )}
    >
      {children}
    </p>
  );
}

export function Paragraph({ children, className, center = false, muted = false }: TextProps) {
  return (
    <p 
      className={cn(
        "body leading-relaxed mb-4",
        center && "text-center",
        muted ? "text-white/60" : "text-white/75",
        className
      )}
    >
      {children}
    </p>
  );
}

export function Subtle({ children, className, center = false }: TextProps) {
  return (
    <p 
      className={cn(
        "body-small",
        center && "text-center",
        className
      )}
    >
      {children}
    </p>
  );
}
